// CartItem.jsx

import noImage from '../slike/noImage.png';
import { formatPrice } from '../../../../../utils/FormatPrice';
// import '../index.css';
import styles from './CartItem.module.css';
import { useTranslation } from 'react-i18next';

const CartItem = ({ item }) => {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <div className={styles.cartItem}>
        <img
          src={item.slikaUrl || noImage}
          alt={item.nazivDela}
          className={styles.cartItemImage}
        />
        <div className={styles.cartItemDetails}>
          <p className={styles.cartItemName}>{item.nazivDela}</p>
          <p className={styles.cartItemName}>
            {t('partNumber')}: {item.partNumber}
          </p>
          <p className={styles.cartItemName}>
            {t('quantity')}: {item.kolicina}
          </p>
          <p className={styles.cartItemName}>
            {t('price')}: {formatPrice(item.fakturnaCena)}{' '}
            <span style={{ color: 'gray', fontSize: '15px' }}>EUR</span>
          </p>
          {/* <p className="cart-item-name">Količina: {item.kolicina}</p> */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <p
              className={styles.cartItemName}
              style={{ minWidth: '100px', textAlign: 'right' }}
            >
              {formatPrice(item.fakturnaCena * item.kolicina)}
            </p>
            <span style={{ color: 'gray' }}>EUR</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
